import {
    ReactNode,
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from "react"
import { LanguageContextType } from "types/Language"

interface ProviderProps {
    language: LanguageContextType
    handleChangeLanguage: (languageContext: LanguageContextType) => void
}

const LanguageContext = createContext<ProviderProps>({
    language: "fr",
    handleChangeLanguage: () => {},
})

interface Props {
    children: ReactNode
}

export const LanguageProvider = ({ children }: Props) => {
    const [language, setLanguage] = useState<LanguageContextType>("fr")
    const handleChangeLanguage = useCallback(
        (languageContext: LanguageContextType) => {
            switch (languageContext) {
                case "fr": // DEFAULT
                    setLanguage("fr")
                    break
                case "en":
                    setLanguage("en")
                    break
            }
        },
        []
    )

    const valueProvider: ProviderProps = useMemo(() => {
        return {
            language,
            handleChangeLanguage,
        }
    }, [language, handleChangeLanguage])

    return (
        <LanguageContext.Provider value={valueProvider}>
            {children}
        </LanguageContext.Provider>
    )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useLanguageContext = () => useContext(LanguageContext)
